<template>
    <div v-if="preview && preview.conflicts && preview.conflicts.length" class="telegram-scope-notice" role="alert">
        <strong>{{ preview.scope === 'object_group' ? 'У объектов уже есть отдельные Telegram-группы' : 'Для группы объектов уже есть Telegram-группы' }}</strong>
        <p v-if="custom" class="mb-1">Проверьте, не совпадает ли назначение произвольных групп.</p>
        <ul class="my-2 pl-3">
            <li v-for="item in preview.conflicts" :key="item.id">
                {{ item.owner_name }}:
                <a v-if="item.chat_id" :href="href(item.chat_id)" target="_blank" rel="noopener noreferrer">{{ item.name }} ↗</a>
                <span v-else>{{ item.name }} · {{ state(item.status) }}</span>
            </li>
        </ul>
        <p class="mb-0">{{ preview.scope === 'object_group' ? 'Существующие группы останутся отдельными; участники и переписка не объединятся.' : 'Отдельная группа будет предназначена только для этого объекта.' }}</p>
    </div>
</template>
<script>
import {telegramGroupHref, telegramGroupStateText} from '@/utils/objectTelegramGroups';
export default {
    props: {preview: Object},
    computed: {custom() { return String(this.preview && this.preview.kind || '').startsWith('custom_'); }},
    methods: {href: telegramGroupHref, state: telegramGroupStateText}
};
</script>
<style scoped>
.telegram-scope-notice {width:100%;padding:12px;border:1px solid #dcc38d;border-radius:8px;background:#fff8e9;color:#634918;font-size:13px;overflow-wrap:anywhere;}
.telegram-scope-notice ul {max-height:180px;overflow:auto;}
</style>
